<snelstart-ui-dialog-definition [(visible)]="this.dialogVisible" id="ti" size="lg" title="{{this.title}}">
    <snelstart-ui-dialog-body [formGroup]="newServiceFg">
        <snelstart-ui-text-form-control [disabledControl]="true"
                                        [required]=true
                                        class="custom-input-275"
                                        formControlName="name"
                                        id="type"
                                        label="Naam"
        >
        </snelstart-ui-text-form-control>
        @if (this.newServiceFg.get('type')?.getRawValue() === 'JR') {
            <snelstart-ui-text-form-control [disabledControl]="true"
                                            [required]=true
                                            class="custom-input-275"
                                            formControlName="fiscalnumber"
                                            id="type"
                                            label="KVK-nummer"
            >
            </snelstart-ui-text-form-control>
            <snelstart-ui-text-form-control [disabledControl]="true"
                                            class="custom-input-275"
                                            formControlName="jrPlaats"
                                            id="jrPlaats"
                                            label="Plaats"
            >
            </snelstart-ui-text-form-control>
        } @else {
            <snelstart-ui-text-form-control [disabledControl]="true"
                                            [required]=true
                                            class="custom-input-275"
                                            formControlName="fiscalnumber"
                                            id="type"
                                            label="Fiscaal nummer"
            >
            </snelstart-ui-text-form-control>
        }
        <snelstart-ui-text-form-control [disabledControl]="true"
                                        [required]=true
                                        class="custom-input-275"
                                        formControlName="type"
                                        id="type"
                                        label="Type"
        >
        </snelstart-ui-text-form-control>
        <snelstart-ui-text-form-control [disabledControl]="true"
                                        [required]=true
                                        class="custom-input-275"
                                        formControlName="year"
                                        id="year"
                                        label="Jaar"
        >
        </snelstart-ui-text-form-control>
        @if (this.newServiceFg.get('type')?.value === 'IB') {
            <snelstart-ui-select-form-control [options]="optionsBiljetsoort"
                                              class="custom-input-275"
                                              formControlName="biljet"
                                              id="biljet"
                                              label="Biljetsoort"
            >
            </snelstart-ui-select-form-control>

            @if (this.newServiceFg.get('biljet')?.value === 'F') {
              <snelstart-ui-alert type="info">
                Kies deze optie bij het overlijden van de aangever.<br/>
                Is een fiscaal partner in het aangiftejaar overleden?
                Kies dan bij de aangever voor een P-biljet en geef aan
                dat de partner is overleden.
              </snelstart-ui-alert>
            }

            @if (this.newServiceFg.get('biljet')?.value === 'C') {
              <snelstart-ui-alert type="info">
                Kies deze optie als er sprake is van iemand die het hele jaar niet in Nederland woont, <br/>
                maar wel inkomen (loon) uit werk in Nederland heeft. Ook de situatie dat 90% of meer van het looninkomen
                <br/>
                in Nederland belast is wordt ondersteund ('kwalificerend buitenlands belastingplichtige').<br/>
                De (uitgebreidere) aangiften voor buitenlands belastingplichtigen met andere inkomsten, woning en/of vermogen in Nederland zijn nog niet beschikbaar.
              </snelstart-ui-alert>}
        }
        @if (this.newServiceFg.get('type')?.getRawValue() === 'JR') {
            @if (jaarrekeningRechtsvormRechtspersoon) {
                <snelstart-ui-select-form-control [disabledControl]="true"
                                                  [options]="this.optionsBedrijfsklasse"
                                                  class="custom-input-275"
                                                  formControlName="jrClassificatie"
                                                  label="Classificatie rechtspersoon"
                >
                </snelstart-ui-select-form-control>
            }
            <snelstart-ui-select-form-control [options]="optionsRechtsvorm"
                                              [required]=true
                                              class="custom-input-275"
                                              formControlName="jrRechtsvorm"
                                              id="jrRechtsvorm"
                                              label="Rechtsvorm">
            </snelstart-ui-select-form-control>
            <snelstart-ui-select-form-control [options]="optionsGrondslagType"
                                              [required]=true
                                              class="custom-input-275"
                                              formControlName="jrGrondslagType"
                                              id="jrGrondslagType"
                                              label="Grondslag jaarrekening">
            </snelstart-ui-select-form-control>
            @if (jaarrekeningRechtsvormRechtspersoon) {
                <snelstart-ui-select-form-control [options]="optionsJaarrekeningType"
                                                  [required]=true
                                                  class="custom-input-275"
                                                  formControlName="jrJaarrekeningType"
                                                  id="jrJaarrekeningType"
                                                  label="Type jaarrekening">
                </snelstart-ui-select-form-control>
            }
        } @else if (this.newServiceFg.get('type')?.value === 'BTW') {
            <snelstart-ui-select-form-control [options]="optionsFrequentie"
                                              class="custom-input-275"
                                              formControlName="frequentie"
                                              id="frequentie"
                                              label="Aangiftefrequentie"
            >
            </snelstart-ui-select-form-control>
        } @else if (this.newServiceFg.get('type')?.value === 'VPB') {
            <snelstart-ui-select-form-control [options]="optionsJaNeeFiscaleEenheid"
                                              class="custom-input-275"
                                              formControlName="fiscaleEenheid"
                                              id="fiscaleEenheid"
                                              label="Fiscale eenheid Vpb?"
            >
            </snelstart-ui-select-form-control>
        }
    </snelstart-ui-dialog-body>

    <snelstart-ui-dialog-buttons class="d-flex">
        <snelstart-ui-button (click)="this.dialogVisibleChange.emit(false)" btn-x class="me-1" id="cancel"
                             type="secondary">Annuleren
        </snelstart-ui-button>
        <snelstart-ui-button (click)="this.saveForm()" [disabled]="saveDisabled()" btn-x icon="check"
                             id="save"
                             type="primary">Opslaan
        </snelstart-ui-button>
    </snelstart-ui-dialog-buttons>
</snelstart-ui-dialog-definition>
